export default __webpack_public_path__ + "static/media/gp-icon-active.b78344a3.svg";